/**
 * Extract the css variable from the :root element. Only works if styles have already been applied, i.e. loaded in main.ts
 */
export function getCSSVariableValue(variable: string) {
    return getComputedStyle(document.documentElement).getPropertyValue(variable);
}
